import { Injectable } from '@angular/core';
import { ERROR_MAPPING } from './error.map';
import { ICardError } from '@app/core/models/error.model';

@Injectable({
  providedIn: 'root',
})
export class MapErrorService {
  constructor() {}

  public mapError(error) {
    let ERRORS = ERROR_MAPPING;
    if (error.statusText === 'Unknown Error') return ERRORS['CORS'];

    const customError: ICardError = error?.error?.error_code;
    if (!!customError) {
      const existMessageError = customError ?? 'default';
      const errorMessage = existMessageError === 'default' ? 'default' : error?.error?.error_code;
      const errorFront = ERRORS[errorMessage];
      return errorFront ? ERRORS[errorMessage] : ERRORS['default'];
    } else {
      const existMessageError = error?.error?.errors ?? 'default';
      const errorMessage =
        existMessageError === 'default' ? 'default' : error?.error?.errors[0]?.message;
      const errorFront = ERRORS[errorMessage];
      return errorFront ? ERRORS[errorMessage] : ERRORS['default'];
    }
  }
}
